module.exports = __webpack_public_path__ + "assets/images/pinning-b7a97c41333ad78ca010609988d51c62.png";